// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import { ProjectProvider } from "./context/ProjectContext.jsx";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import { StorageProvider } from "./storage/StorageProvider.jsx";
import { initPosthog } from "./lib/posthog";
import { initGoogleAnalytics } from "./lib/ga";

// Keep analytics providers isolated so one SDK failure does not block the other.
try {
  initGoogleAnalytics();
} catch (error) {
  // eslint-disable-next-line no-console
  void 0;
}

try {
  initPosthog();
} catch (error) {
  // eslint-disable-next-line no-console
  void 0;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <StorageProvider>
        <ProjectProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ProjectProvider>
      </StorageProvider>
    </AuthProvider>
  </React.StrictMode>
);
